import { SxProps, Theme } from '@mui/material';

import { CenteredLayout } from '../layout/CenteredLayout';
import { CircularProgress, CircularProgressSize } from './CircularProgress';

export type CenteredSpinnerProps = { size?: CircularProgressSize; sx?: SxProps<Theme> };

export function CenteredSpinner({ size, sx }: CenteredSpinnerProps): JSX.Element {
    return (
        <CenteredLayout sx={sx}>
            <CircularProgress size={size} />
        </CenteredLayout>
    );
}
